export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm text-primary-600 font-medium bg-primary-50 px-3 py-1 rounded-full">联系我们</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950">联系我们</h2>
          <p className="mt-2 text-sm text-foreground-500">有料就爆，欢迎投稿</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-1 space-y-4">
              <div className="bg-background-100 border border-background-200/70 rounded-xl p-5">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg mb-3">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">投稿邮箱</h3>
                <p className="text-sm text-foreground-500">tips@911baoliao.com</p>
              </div>
              <div className="bg-background-100 border border-background-200/70 rounded-xl p-5">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg mb-3">
                  <i className="ri-wechat-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">官方微信</h3>
                <p className="text-sm text-foreground-500">911baoliao_official</p>
              </div>
              <div className="bg-background-100 border border-background-200/70 rounded-xl p-5">
                <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 rounded-lg mb-3">
                  <i className="ri-shield-check-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">隐私承诺</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">所有爆料人信息严格保密，采用加密传输，绝不泄露。</p>
              </div>
            </div>

            <div className="lg:col-span-2">
              <div className="bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-8">
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-6">快速投稿</h3>
                <form className="space-y-5" onSubmit={(e) => { e.preventDefault(); }}>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-medium text-foreground-700 mb-2">你的昵称</label>
                      <input
                        type="text"
                        name="nickname"
                        placeholder="输入你的昵称"
                        className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-foreground-700 mb-2">联系方式</label>
                      <input
                        type="text"
                        name="contact_info"
                        placeholder="邮箱或微信号（选填）"
                        className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-2">爆料主题</label>
                    <input
                      type="text"
                      name="subject"
                      placeholder="简要描述你要爆料的内容"
                      className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-2">详细内容</label>
                    <textarea
                      name="content"
                      rows={5}
                      maxLength={500}
                      placeholder="请详细描述爆料内容，越详细越容易被采纳…"
                      className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                    ></textarea>
                    <p className="mt-1 text-xs text-foreground-400">最多 500 字</p>
                  </div>
                  <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="absolute left-[-9999px] opacity-0 h-0 w-0 overflow-hidden pointer-events-none" />
                  <button
                    type="submit"
                    className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap text-sm"
                  >
                    <i className="ri-send-plane-line mr-2"></i>提交爆料
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}